import { Button, Tooltip } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { NewsTabs } from '~/components/news-tabs/NewsTabs';
import { RenderFeatureFlag } from '~/components/render-feature-flag/RenderFeatureFlag';
import { useTerminalNavigate } from '~/hooks/use-terminal-navigate/useTerminalNavigate';
import { appPaths } from '~/routes/app-paths';
import { FeatureFlags } from '~/stores/use-feature-flags/feature-flags.types';
import { TabsType } from '~/views/news/utils/utils';

import * as S from './WidgetHeader.styles';

export interface WidgetHeaderProps {
  activeTab: TabsType;
  onChangeTab: (_: number, tabKey: TabsType) => void;
}

export const WidgetHeader = ({ activeTab, onChangeTab }: WidgetHeaderProps) => {
  const { t } = useTranslation(['news']);

  const navigateTerminal = useTerminalNavigate();

  const onClickExpand = () => {
    navigateTerminal({
      to: {
        pathname: appPaths.news,
      },
      crumb: {
        isSidebar: true,
        label: t('common:sideNavigation.news'),
      },
    });
  };

  return (
    <S.WidgetHeaderWrapper data-testid="header-wrapper">
      <NewsTabs activeTab={activeTab} onChange={onChangeTab} />
      <S.BtnsAndTimeWrapper>
        <RenderFeatureFlag requiredFlag={FeatureFlags.ENABLE_NEWS}>
          <Tooltip
            isTouchDevice={false}
            label={t('news:viewMoreNews')}
            strategy="fixed"
          >
            <Button
              data-testid="btn-navigate"
              variant="tertiary"
              size="small"
              iconName="Expand"
              onClick={onClickExpand}
            />
          </Tooltip>
        </RenderFeatureFlag>
      </S.BtnsAndTimeWrapper>
    </S.WidgetHeaderWrapper>
  );
};
